const Navigator = ({ children }) => {
  return (
    <div className="mb-10 flex flex-col items-start justify-between sm:flex-row sm:items-center">
      {children}
    </div>
  );
};

export default Navigator;
